import React, { useCallback, useLayoutEffect } from 'react';
import StatusBar from 'design-system/StatusBar';
import useColors from 'hooks/useColors';
import { useAppDispatch } from 'store/hooks';
import { SelectAccountsPage } from './containers';
import { setSelectedSpace } from './actions';
const JoinedSpaceAddAccountsScreen = ({ route, navigation }) => {
    const spaceInfo = route.params?.spaceInfo;
    const space = spaceInfo?.space;
    const colors = useColors();
    const dispatch = useAppDispatch();
    useLayoutEffect(() => {
        navigation.setOptions({
            title: 'Add accounts',
            headerTitle: '',
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const onNext = useCallback(() => {
        if (space) {
            dispatch(setSelectedSpace(space.id));
        }
        navigation.navigateDeprecated('Success', {
            title: 'You’re ready to manage your finances together',
            subTitle: 'Let’s explore your new Space',
            onContinue: () => {
                navigation.popToTop();
                navigation.navigateDeprecated('Feed');
                return true;
            },
            buttonText: 'Done',
        });
    }, [space]);
    return (<>
        <StatusBar barStyle="dark-content" animated/>
        <SelectAccountsPage spaceInfo={spaceInfo} onFinish={onNext} title="Let’s add your accounts" subtitle="The balances and transactions of your accounts will be shared in the Space, but don’t worry — no one can move money from your accounts" submitButtonText="Continue"/>
      </>);
};
export default JoinedSpaceAddAccountsScreen;
